import * as React from 'react';

const LoaderIcon = (props) => {
    return (
        <div className="d-flex justify-content-center">
            <div className={`loader la-ball-pulse la-dark ${props.customClass ? props.customClass : ''}`}>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    );
};

export default LoaderIcon;
